import Modal from './components/Modal';

const modal = new Modal();
modal.init();
